<template>
    <div class="container-guest p-5 d-flex flex-column align-items-center">
        <div class="overlayFP"></div>
        <div class="overlayFP-container" v-if="viewForgetPassword">
            <img src="@/assets/images/ic_thank_you.svg">
            <p class="overlayFP-title">Thank you</p>
            <p class="overlayFP-subtitle">Your email has been sent, <span>please check your inbox now.</span></p>
            <button @click="dismissAlertFP()" class="btn">DONE</button>
        </div>
        <div class="overlayPersonalize-container" v-if="viewPersonalization">
            <p class="overlayPersonalize-title">Invoice Personalization</p>
            <p class="overlayPersonalize-subtitle">Create the perfect invoice to match your brand. This will take a minute!</p>
            <button class="overlayPersonalize-btnskip" @click="skipPersonalize()">SKIP</button>
            <button class="overlayPersonalize-btproceed" @click="proceedPersonalize()">PERSONALIZE</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            viewForgetPassword: Boolean,
            viewPersonalization: Boolean,
        },
        methods: {
            dismissAlertFP(){
                this.$root.$emit('dismiss-alert-view-fp');
            },
            proceedPersonalize(){
                this.$root.$emit('proceed-personalize');
            },
            skipPersonalize(){
                this.$root.$emit('skip-personalization');
            },
        }
    }
</script>